import React, { useState, useEffect } from 'react';
import { SliderData } from '../SliderData';
import { useStateValue } from '../../../services/ContextProvider';
import './Guides.css';

const Guides = ({ current, changeCurrent, carouselArr }) => {
	const { globalState } = useStateValue();
	const [sliderData, setSilderData] = useState(SliderData);

	useEffect(() => setSilderData(globalState.globalCarousel || []), [globalState.globalCarousel]);

	return (
		<div className="guid-container">
			{sliderData.map((slide, index) => {
				return (
					<div key={index}
						className={index === current ? 'guid-dot active' : 'guid-dot'}
						onClick={() => { changeCurrent(index); }}></div>
				);
			})}
		</div>
	);
};

export default Guides;
